import React from "react";
import Header from "../../components/header/Header";
import See from "../../components/seeHW/See";
const teacher = () => {
  return (
    <>
      <Header />
      <See />)
    </>
  );
};

export default teacher;
